import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=6b792611&scoped=true&"
import script from "./SearchNoResults.vue?vue&type=script&lang=js&"
export * from "./SearchNoResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchNoResults.vue?vue&type=style&index=0&id=6b792611&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b792611",
  null
  
)

export default component.exports